module.exports = __webpack_public_path__ + "static/media/ic_expand_arrow_primary.472ed79a.svg";